module.exports = __webpack_public_path__ + "img/master.e2698f2c.png";